export const ICON_CLASS = {
  LIVE: 'live-empty',
  MATCH_DETAILS: 'livedetails-empty',
  HIGHLIGHTS: 'highlights-empty',
  FAVORITES: 'favorite-empty',
  OUTRIGHTS: 'outrights-empty',
  MYBETS: 'betslip-history-empty',
  BETSLIP: 'betslip-empty',
  LOADING: 'bto-sb-spinner-v2',
  HORSE: 'horseracing-empty',
  GREYHOUND: 'greyhound-empty',
};
